import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Analytics } from '@vercel/analytics/react';
import ScrollToTop from './components/ScrollToTop';
import './App.css';

// Layout Components
import Navbar from './components/Layout/Navbar';
import Footer from './components/Layout/Footer';

// Page Components
import HomePage from './components/Home/HomePage';
import AboutPage from './components/About/AboutPage';
import ServicesPage from './components/Services/ServicesPage';
import ServiceDetail from './components/Services/ServiceDetail';
import IndustriesPage from './components/Industries/IndustriesPage';
import CareersPage from './components/Careers/CareersPage';
import JobApplication from './components/Careers/JobApplication';
import ContactPage from './components/Contact/ContactPage';

function App() {
  return (
    <div className="app">
      <Analytics />
      <ScrollToTop />
      <Navbar />
      <main className="main-content">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/services/:serviceId" element={<ServiceDetail />} />
          <Route path="/industries" element={<IndustriesPage />} />
          <Route path="/industries/:industryId" element={<IndustriesPage />} />
          <Route path="/careers" element={<CareersPage />} />
          <Route path="/careers/apply" element={<JobApplication />} />
          <Route path="/contact" element={<ContactPage />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;